<template>
  <div class="user-limit-desktop" :class="userLimitClasses">
    <div :key="0" class="wrapper">
      <transition name="fade" mode="out-in">
        <div v-if="!temporaryUserLimitSet" class="call-to-scroll">
          <g-title size="s" tag="h2" color="white">
            {{ callToScrollTitle }}
          </g-title>
          {{ callToScrollText }}
        </div>
        <div v-else class="call-to-scroll">
          <p>{{ limitSetFeedbackText }}</p>
          <g-button
            v-if="temporaryUserLimitSet"
            size="small"
            color="white"
            narrow
            @click="setUserLimit"
          >
            GÅ VIDARE
          </g-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    temporaryUserLimitSet: {
      type: Boolean,
      default: false
    },
    callToScrollText: {
      type: String,
      default: ''
    },
    callToScrollTitle: {
      type: String,
      default: ''
    },
    limitSetFeedbackText: {
      type: String,
      default: ''
    }
  },

  computed: {
    userLimitClasses() {
      return {
        show: this.visible
      };
    }
  },
  methods: {
    setUserLimit(e) {
      this.$emit('set-user-limit', e);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-limit-desktop {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  left: 10px;

  position: fixed;
  right: auto;
  top: 40%;
  transform: translateX(-110%);
  transition: transform 0.9s ease-out;

  z-index: 3;

  &.show {
    transform: translateX(0);
  }

  .wrapper {
    //width: 100%;
    margin: auto;
    max-width: 400px;
  }

  .call-to-ecpat,
  .call-to-scroll {
    border-radius: 20px;

    box-shadow: 0 0 9px 2px rgba(0, 0, 0, 0.4);
    color: $white;
    font-size: 16px;
    font-weight: 400;
    padding: 25px;
  }

  .call-to-scroll {
    background-color: $green;
  }

  .call-to-ecpat {
    background-color: $brown;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
